import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import VerifiedRounded from '@mui/icons-material/VerifiedRounded';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import GavelRounded from '@mui/icons-material/GavelRounded';
import AccountTreeRounded from '@mui/icons-material/AccountTreeRounded';
import FlashOnRounded from '@mui/icons-material/FlashOnRounded';
import SchoolRounded from '@mui/icons-material/SchoolRounded';
import HandshakeRounded from '@mui/icons-material/HandshakeRounded';
import { useTranslation } from 'react-i18next';

import { PanelSection, CheckList } from './DetailPanel';
import { azure, emerald } from '../theme';

const SERVICE_ICONS = [
  VerifiedRounded,
  WarningAmberRounded,
  GavelRounded,
  AccountTreeRounded,
  FlashOnRounded,
  SchoolRounded,
];

// Deep-dive content for the Cybersecurity & Compliance practice,
// delivered in partnership with Infintrix. Fully translated (EN/AR).
export default function Cybersecurity() {
  const { t } = useTranslation();

  const services = [1, 2, 3, 4, 5, 6].map((n, i) => ({
    icon: SERVICE_ICONS[i],
    title: t(`cyberd.s${n}t`),
    description: t(`cyberd.s${n}d`),
  }));

  return (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {t('cyberd.intro')}
      </Typography>

      <Box
        sx={{
          mt: 3,
          p: 2.5,
          borderRadius: 3,
          display: 'flex',
          gap: 1.75,
          alignItems: 'flex-start',
          border: `1px solid ${alpha(emerald[400], 0.35)}`,
          bgcolor: alpha(emerald[400], 0.07),
        }}
      >
        <HandshakeRounded sx={{ color: emerald[300], mt: '2px' }} />
        <Typography variant="body2" sx={{ color: 'text.primary' }}>
          {t('cyberd.partner')}
        </Typography>
      </Box>

      <PanelSection title={t('cyberd.servicesTitle')}>
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' } }}>
          {services.map(({ icon: Icon, title, description }) => (
            <Card key={title} sx={{ p: 2.5 }}>
              <Icon sx={{ color: azure[300], mb: 1.25 }} />
              <Typography variant="h6" component="h4" gutterBottom>
                {title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Card>
          ))}
        </Box>
      </PanelSection>

      <PanelSection title={t('cyberd.whyTitle')}>
        <CheckList
          items={[t('cyberd.why1'), t('cyberd.why2'), t('cyberd.why3'), t('cyberd.why4')]}
        />
      </PanelSection>
    </Box>
  );
}
